$yuf_number_range_string $mol_string
	type \range
	keyboard \decimal
	attr *
		^
		title <= hint
	field *
		^
		step <= step 1
		min <= min 0
		max <= max 100
